import {Route} from '@angular/router';
import {PlanDashboardComponent} from './plan-dashboard/plan-dashboard.component';
import {LodgeFieldRecordComponent} from './lodge-field-record/lodge-field-record.component';
import {UserAccountDetailsComponent} from './user-account-details/user-account-details.component';
import {MaintainFirmComponent} from './maintain-firm/maintain-firm.component';
import {HomeComponent} from './home/home.component';
import {PlanDetailComponent} from './plan-detail/plan-detail.component';
import {BootstrapPlaygroundComponent} from './bootstrap-playground/bootstrap-playground.component';
import {HelpComponent} from './help/help.component';
import {WindowWidgetsComponent} from './design/window-widgets/window-widgets.component';
import {ExtractCadastreComponent} from './extract-cadastre/extract-cadastre.component';

// Please refer to paths defined in `js/app.js`.
export const routes: Route[] = [
    {
        path: '',
        component: HomeComponent
    },
    {
        path: 'redirect-home',
        component: HomeComponent
    },
    {
        path: 'plan-dashboard',
        component: PlanDashboardComponent
    },
    {
        path: 'lodge-field-record',
        component: LodgeFieldRecordComponent
    },
    {
        path: 'user-account-details',
        component: UserAccountDetailsComponent
    },
    {
        path: 'maintain-firm',
        component: MaintainFirmComponent
    },
    {
        path: 'plan/:action',
        component: PlanDetailComponent,
        canDeactivate: [(component: PlanDetailComponent) => component.canDeactivate()]
    },
    {
        path: 'plan/:action/:planLodgementId',
        component: PlanDetailComponent,
        canDeactivate: [(component: PlanDetailComponent) => component.canDeactivate()]
    },
    {
        path: 'window-widgets',
        component: WindowWidgetsComponent
    },
    {
        path: 'bsplayground',
        component: BootstrapPlaygroundComponent
    },
    {
        path: 'help',
        component: HelpComponent
    },
    {
        path: 'extract-cadastre',
        component: ExtractCadastreComponent
    }
];
